import { BaseComponent } from '../../../../../../components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { Modal, ModalControls } from '../../../../../../components/Modal';
import { Button } from '../../../../../../components/Buttons';
import { Checkbox } from '../../../../../../components/Checkbox';
import { HBox, VBox } from '../../../../../../components/Box';
import { VehicleCreditorField } from './Fields';
import { fetchCompany, setCompanyProperty, toggleNotification } from '../../../../../Companies/actions';
import { selectNewVehicle } from '../../../../../Vehicles/selectors';
import { getPropByName } from '../../../../../../utils/props';
import { setNewVehicleValue } from '../../../../../Vehicles/actions';
import { selectConfig, selectWork, selectWorks } from '../../../../../Api/selectors';
import { CompanyQuickCreator } from '../../../../../Companies/pages/QuickCreate';
import {
  COMPANY_VINDAT_TRANSPORT_PURPOSE_OPTION,
  REQUEST_COMPANY_ADD_USER,
  REQUEST_COMPANY_PROPERTY_UPDATE,
} from '../../../../../Companies/constants';
import { REQUEST_USER } from '../../../../../Users/constants';
import { selectNotification } from '../../../../../Companies/selectors';
import { Notification } from '../../../../../../components/Notification';
import { selectNewInvoice } from '../../../../selectors';
import { setNewInvoiceValue } from '../../../../actions';
import env from '../../../../../../env';
import { AppClientId } from '../../../../../Shared/constants';
import { mapIncomingInvoiceToCopy } from '../../../../helpers';

const Container = styled.div`
  visibility: ${props => (props.customerModal ? 'hidden' : '')};
`;

const User = styled.div`
  border: ${props => (!!props.isActive ? '1px solid rgb(21, 172, 121)' : '1px solid grey')};
  border-radius: 6px;
  padding: 12px;
  width: calc(33% - 10px);
  min-height: 140px;
  margin: 6px 0;
  font-size: 12px;

  @media (max-width: 768px) {
    width: 100%;
  }

  .button {
    margin: 0 -12px;
  }
  .name {
    font-size: 12px;
  }
  .user {
    margin-top: 12px;
  }

  .req-field-message {
    color: red;
  }
`;

const STATE = {
  creditorCompany: null,
  user: null,
  showCustomerModal: false,
  no_release_before_incoming_transport: '0',
  no_incoming_payment_before_transport: '0',
  wait_for_pickup: '0',
  showPopup: true,
};

/* eslint-disable react/prefer-stateless-function */
class SelectCreditorModalComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {
    if (this.props.copyFromInvoice?.id) {
      Object.entries(mapIncomingInvoiceToCopy(this.props.copyFromInvoice))?.map(value => {
        this.props.setValue(value[1], value[0]);
      });
    }
    if (this.props.values.creditor_company) {
      this.props.fetchCompany(this.props.values?.creditor_company, result => {
        if (result.id) {
          this.setState({ creditorCompany: result });
          const user = result?.users?.find(user => user?.id == this.props.values?.creditor);
          this.handleSetUser(user);
        }
      });
    }
  }

  componentDidUpdate(prevProps) {
    const { fetchCompany, values } = this.props;
    if (values?.creditor && !this.state.user) {
      const user = this.state.creditorCompany?.users?.find(user => user?.id == this.props.values?.creditor);
      this.handleSetUser(user);
    }
    if (prevProps.values?.creditor_company !== values.creditor_company) {
      fetchCompany(values?.creditor_company, result => {
        if (result.id) {
          this.setState({ creditorCompany: result });
        }
      });
    }
    if (!this.state.creditorCompany && values.creditor_company) {
      fetchCompany(values?.creditor_company, result => {
        if (result.id) {
          this.setState({ creditorCompany: result });

          if (this.props.tradeInVehicle) {
            const user = result?.users?.find(u => u.id == this.props.defaultCreditorUser);
            this.handleSetUser(user);
          }
        }
      });
    }

    if (this.props.notification?.isShow) {
      this._t = this.timeout(
        () => {
          this.props.toggleNotification();
        },
        5000,
        this._t,
      );
    }
  }

  get isShowCreditorPopup() {
    const isShow =
      this.state.showPopup &&
      (!getPropByName(this.state.creditorCompany, 'no_release_before_incoming_transport') ||
        !getPropByName(this.state.creditorCompany, 'no_incoming_payment_before_transport') ||
        !getPropByName(this.state.creditorCompany, 'wait_for_pickup'));
    return isShow;
  }

  handleSetUser = u => {
    this.setState({ user: u });
    if (!!u) {
      return this.props.setValue(u.id, 'creditor');
    }
  };

  openCustomerModal() {
    this.setState({ showCustomerModal: true });
  }

  applyDisabled() {
    //TODO-3500
    return false;
    if (!this.props.values?.creditor_company) return true;
    if (!this.props.values?.creditor && !this.props?.serverConfig?.incomingContactOptional) return true;

    return getPropByName(this.state.creditorCompany, 'incoming_block') === '1';
  }

  onPropertySelect(propertyName) {
    if (this.state[propertyName] === '0') {
      return this.setState({ [propertyName]: '1' });
    }
    return this.setState({ [propertyName]: '0' });
  }

  editCompany() {
    let props = COMPANY_VINDAT_TRANSPORT_PURPOSE_OPTION.map(prop => [prop, this.state[prop]]);

    this.props.onUpdateCompanyProps(this.state.creditorCompany?.id, props, result => {
      this.setState({ showPopup: false });
    });
  }

  render() {
    console.log('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!');
    console.log('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!');
    console.log('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!');
    console.log('HERE', this.state);
    console.log('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!');
    console.log('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!');
    console.log('!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!');
    return (
      <>
        {this.state.showCustomerModal && (
          <CompanyQuickCreator incomingModal={true} resetQuickModal={() => this.setState({ showCustomerModal: false })} />
        )}
        {this.props.notification?.isShow === '1' && (
          <Notification>{this.lbl(`company.create.${this.props.notification?.message}`)}</Notification>
        )}
        <Container customerModal={this.state.showCustomerModal}>
          <Modal mediumWide onClose={this.props.reset} title={this.lblStr('vehicle.create.select_creditor')}>
            {this.state.creditorCompany?.id && this.isShowCreditorPopup}
            {!this.props.work && (
              <VBox left>
                {!this.props.tradeInVehicle
                  ? (() => {
                      return (
                        <VehicleCreditorField
                          key={'creditor_company'}
                          type={'creditor_company'}
                          invoicePage={this.props.invoicePage}
                          showNewCompanyModal={this.openCustomerModal.bind(this)}
                        />
                      );
                    })()
                  : (() => {
                      return (
                        <VehicleCreditorField
                          tradeInVehicle
                          order
                          key={'creditor_company'}
                          type={'creditor_company'}
                          invoicePage={this.props.invoicePage}
                          showNewCompanyModal={this.openCustomerModal.bind(this)}
                        />
                      );
                    })()}

                {!env.wientjes_installation && !env.autohuis_salland_installation && (
                  <HBox left flexWrap flip={window.innerWidth < 768} style={{ gap: 10 }} className={'address-block'}>
                    {this.state.creditorCompany?.users?.length === 0 ? (
                      <HBox>
                        {env.clientId === AppClientId.INDEWAL ? (
                          <strong>{this.lbl('company.notification.selection_isnt_possible')}</strong>
                        ) : (
                          <strong>{this.lbl('company.notification.selection_isnt_possible_hooikammer')}</strong>
                        )}
                      </HBox>
                    ) : (
                      this.state.creditorCompany?.users.map(user => (
                        <User
                          key={`${user?.id}`}
                          onClick={() => this.handleSetUser(user)}
                          isActive={this.state.user?.id == user?.id}
                        >
                          <VBox spaceAround className="user-box">
                            <HBox vCenter>
                              <h3 className="name">
                                {getPropByName(user, 'name')}&nbsp;{getPropByName(user, 'surname')}
                              </h3>
                              <Checkbox checked={this.state.user?.id === user?.id} />
                            </HBox>
                            <VBox className="user">
                              <div>{user['email_address']}</div>
                            </VBox>
                          </VBox>
                        </User>
                      ))
                    )}
                  </HBox>
                )}
              </VBox>
            )}
            {getPropByName(this.state.creditorCompany, 'incoming_block') === '1' && (
              <HBox>
                <strong>{this.lbl('company.block_invoice_sorry')}</strong>
              </HBox>
            )}
            <ModalControls>
              <Button
                onClick={() => {
                  ['creditor_company', 'creditor'].map(type => this.props.setValue(null, type));
                  this.props.reset();
                }}
              >
                {this.lbl(`cancel`)}
              </Button>
              <Button primary disabled={false} onClick={() => this.props.onConfirm()}>
                {this.lbl(`confirm`)}
              </Button>
            </ModalControls>
          </Modal>
        </Container>
      </>
    );
  }
}

SelectCreditorModalComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  onClose: PropTypes.func,
  reset: PropTypes.func,
  onNextModal: PropTypes.func,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    values: ownProps.invoicePage ? selectNewInvoice() : selectNewVehicle(),
    work: selectWorks([REQUEST_COMPANY_ADD_USER, REQUEST_USER]),
    workCompanyEdit: selectWork(REQUEST_COMPANY_PROPERTY_UPDATE),
    notification: selectNotification(),
    serverConfig: selectConfig(),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    setValue(value, name = null) {
      name = name ?? ownProps.type;
      ownProps.invoicePage ? dispatch(setNewInvoiceValue(name, value)) : dispatch(setNewVehicleValue(name, value));
    },
    fetchCompany(id, callback) {
      dispatch(fetchCompany(id, callback));
    },
    toggleNotification() {
      dispatch(toggleNotification('0'));
    },
    onUpdateCompanyProps(companyId, props, callback) {
      props.map((prop, index) =>
        dispatch(setCompanyProperty(companyId, prop[0], prop[1], index == props.length - 1 && callback)),
      );
      // dispatch(setCompanyProperty(companyId, name, value, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const SelectCreditorModal = compose(withConnect, withRouter, injectIntl)(SelectCreditorModalComp);
